export default __webpack_public_path__ + "static/media/preloader1.af17ae06.gif";